export default {
  // document.body.clientWidth
  state: {
    screenWidth: 1200
  },
  actions: {
    getSwiper ({ }, callback) {
      if (window.Swiper) {
        callback && callback();
      } else {
        let swiperScript = document.createElement('script');
        swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/Swiper4.4.6/dist/js/swiper.min.js');
        swiperScript.onload = swiperScript.onreadystatechange = function () {
          if (swiperScript.ready) return false;
          if (!swiperScript.readyState || swiperScript.readyState == 'loaded' || swiperScript.readyState == 'complete') {
            callback && callback();
            swiperScript.onload = swiperScript.onreadystatechange = null;
            swiperScript.ready = true;
          }
        };
        document.getElementsByTagName('body')[0].appendChild(swiperScript);
      }
    },
    getProviceCityArea ({ }, callback) {
      if (window.proviceCityArea) {
        callback && callback();
      } else {
        let swiperScript = document.createElement('script');
        // swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/proviceCity/_threeCity.js');
        swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/proviceCity/threeCity.js');
        swiperScript.onload = swiperScript.onreadystatechange = function () {
          if (swiperScript.ready) return false;
          if (!swiperScript.readyState || swiperScript.readyState == 'loaded' || swiperScript.readyState == 'complete') {
            callback && callback();
            swiperScript.onload = swiperScript.onreadystatechange = null;
            swiperScript.ready = true;
          }
        };
        document.getElementsByTagName('body')[0].appendChild(swiperScript);
      }
    },
  },
  mutations: {

  },
};



// WEBPACK FOOTER //
// ./src/store/common/common.js